// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal.active div.modal-overlay {
  background: var(--main-modal-overlay-color);
}
.modal .modal-container {
  border: 0;
  justify-content: space-between;
  background-color: var(--main-bg-color-lighter);
  border-radius: var(--main-border-radius);
  box-shadow: 0px 0px 0.5rem 0.2rem color-mix(in srgb, #000, transparent 50%);
}
.modal.active {
  overflow: scroll !important;
  display: -webkit-flex !important;
}
.modal .modal-close {
  position: absolute;
  right: 0;
  top: auto;
}
.modal .modal-header {
  position: relative;
  text-align: center;
  padding: 0.8rem 0 !important;
  border-bottom: var(--main-border-width) solid var(--main-border-color);
  color: var(--main-text-color);
}
.modal .modal-header .modal-title-text {
  margin-bottom: 0;
  text-align: center;
}
.modal .modal-header .modal-title-text h1,
.modal .modal-header .modal-title-text h2,
.modal .modal-header .modal-title-text h3,
.modal .modal-header .modal-title-text h4,
.modal .modal-header .modal-title-text h5 {
  margin: 0;
}
.modal .modal-body {
  padding: 1rem;
}
.modal .modal-footer .modal-footer-text {
  margin-bottom: 45px;
  margin-left: 30px;
  margin-right: 30px;
  text-align: left;
  font-weight: 300;
  line-height: 1.2;
  margin-top: 0;
}
.modal .modal-footer .modal-controls {
  display: flex;
  justify-content: center;
  column-gap: 3rem;
}
.modal.modal-size-small .modal-container {
  width: 100%;
  max-width: 420px !important;
  min-height: 275px;
}
.modal.modal-size-compact .modal-container {
  width: 100%;
  max-width: 420px !important;
  min-height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/BaseModal/BaseModal.less"],"names":[],"mappings":"AACE;EACE,2CAAA;AAAJ;AAFA;EAMI,SAAA;EACA,8BAAA;EACA,8CAAA;EACA,wCAAA;EACA,2EAAA;AADJ;AAIE;EACE,2BAAA;EACA,gCAAA;AAFJ;AAbA;EAmBI,kBAAA;EACA,QAAA;EACA,SAAA;AAHJ;AAlBA;EAyBI,kBAAA;EACA,kBAAA;EACA,4BAAA;EACA,sEAAA;EACA,6BAAA;AAJJ;AAzBA;EAgCM,gBAAA;EACA,kBAAA;AAJN;AA7BA;;;;;EAwCQ,SAAA;AAJR;AApCA;EA8CI,aAAA;AAPJ;AAvCA;EAmDM,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AATN;AAhDA;EA6DM,aAAA;EACA,uBAAA;EACA,gBAAA;AAVN;AAeE;EAEI,WAAA;EACA,2BAAA;EACA,iBAAA;AAdN;AAkBE;EAEI,WAAA;EACA,2BAAA;EACA,gBAAA;AAjBN","sourcesContent":[".modal {\n  &.active div.modal-overlay {\n    background: var(--main-modal-overlay-color);\n  }\n\n  .modal-container {\n    border: 0;\n    justify-content: space-between;\n    background-color: var(--main-bg-color-lighter);\n    border-radius: var(--main-border-radius);\n    box-shadow: 0px 0px .5rem .2rem color-mix(in srgb, #000, transparent 50%);\n  }\n\n  &.active {\n    overflow: scroll !important;\n    display: -webkit-flex !important;\n  }\n\n  .modal-close {\n    position: absolute;\n    right: 0;\n    top: auto;\n  }\n\n  .modal-header {\n    position: relative;\n    text-align: center;\n    padding: .8rem 0 !important;\n    border-bottom: var(--main-border-width) solid var(--main-border-color);\n    color: var(--main-text-color);\n\n    .modal-title-text {\n      margin-bottom: 0;\n      text-align: center;\n\n      h1,\n      h2,\n      h3,\n      h4,\n      h5 {\n        margin: 0;\n      }\n    }\n  }\n\n  .modal-body {\n    padding: 1rem;\n  }\n\n  .modal-footer {\n    .modal-footer-text {\n      margin-bottom: 45px;\n      margin-left: 30px;\n      margin-right: 30px;\n      text-align: left;\n      font-weight: 300;\n      line-height: 1.2;\n      margin-top: 0;\n    }\n\n    .modal-controls {\n      display: flex;\n      justify-content: center;\n      column-gap: 3rem;\n    }\n  }\n\n  // size variations\n  &.modal-size-small {\n    .modal-container {\n      width: 100%;\n      max-width: 420px !important;\n      min-height: 275px;\n    }\n  }\n\n  &.modal-size-compact {\n    .modal-container {\n      width: 100%;\n      max-width: 420px !important;\n      min-height: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
